import React from 'react';
import BaseIcon from './BaseIcon';

class CopySVG extends BaseIcon {
  render() {
    const { className, fillColor, height, width, style } = this.props;
    return (
      <svg
        width={width}
        height={height}
        viewBox="0 0 110.41 107.72"
        xmlns="http://www.w3.org/2000/svg"
        cursor="pointer"
        className={className}
        style={style}
      >
        <g transform="translate(-19.794 -21.141)">
          <g transform="translate(-3.3095 -3.0288)">
            <path
              d="m111.01 52.35h13.703c2.7377 0 4.9417 2.204 4.9417 4.9417v65.864c0 2.7377-2.204 4.9417-4.9417 4.9417h-68.207c-2.7377 0-4.9417-2.204-4.9417-4.9417v-12.947m-14.49-77.006h68.207c2.7377 0 4.9417 2.204 4.9417 4.9417v65.864c0 2.7377-2.204 4.9417-4.9417 4.9417h-68.207c-2.7377 0-4.9417-2.204-4.9417-4.9417v-65.864c0-2.7377 2.204-4.9417 4.9417-4.9417z"
              fill="none"
              stroke={fillColor}
              strokeLinejoin="round"
              strokeWidth="4.065"
            />
          </g>
        </g>
      </svg>
    );
  }
}

export default CopySVG;
